<template>
  <div style="width:100%;overflow-y:auto;overflow-x:hidden;height:100%;">
    <div style="padding:0px;width:100%;">
      <div style="width:235px;float: left;" class="whiteBox searchbox">
        <h4><i class="el-icon-d-arrow-right"></i> 筛选条件</h4>
        <div class="filter-container search-box">
          <el-form label-position="top" label-width="80px">
            <el-form-item label="搜索">
              <el-input size="mini" style="width:180px;top:2px;" placeholder="姓名或手机号"
                v-model="searchQuery.key"></el-input>
            </el-form-item>
            <!-- <el-form-item label="跟进时间" v-if="filterType != 0">
                            <el-date-picker v-model="searchQuery.followDateRange" type="daterange" size="mini" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="datePickerOption" value-format="timestamp">
                            </el-date-picker>
            </el-form-item>-->
            <el-form-item label="客户级别">
              <el-select size="mini" style="width:180px;" multiple v-model="searchQuery.level">
                <el-option v-for="item in levelOptions" :key="item.dataName" :label="item.dataDisplay"
                  :value="item.dataName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="线索来源">
              <el-select size="mini" style="width:180px;" v-model="searchQuery.fromType">
                <el-option label="全部" :value="0"></el-option>
                <el-option label="线上" :value="1"></el-option>
                <el-option label="线下" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="成员" v-if="members.length > 1">
              <el-select size="mini" style="width:180px;" multiple v-model="searchQuery.member">
                <el-option v-for="item in members" :key="item.memberId" :label="item.userName"
                  :value="item.memberId"></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="购车类型">
                            <el-select size="mini" style="width:180px;" multiple v-model="searchQuery.businessType">
                                <el-option v-for="item in businessTypeOptions" :key="item.dataValue" :label="item.dataDisplay" :value="item.dataValue">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="线下来源">
                            <el-select size="mini" style="width:180px;" multiple v-model="searchQuery.fromSource">
                                <el-option v-for="item in fromSourceOptions" :key="item.dataValue" :label="item.dataDisplay" :value="item.dataValue">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="线上来源">
                            <el-select size="mini" style="width:180px;" multiple v-model="searchQuery.onlineSource">
                                <el-option v-for="item in importSourceOptions" :key="item.dataName" :label="item.dataDisplay" :value="item.dataName">
                                </el-option>
                            </el-select>
            </el-form-item>-->
            <el-form-item label="车系">
              <el-select size="mini" style="width:180px;" multiple v-model="searchQuery.series">
                <el-option v-for="item in carOptions" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="完成时间" v-if="filterType === 3">
              <el-date-picker v-model="searchQuery.followDateRange" type="daterange" size="mini" range-separator="至"
                :clearable="false" start-placeholder="开始日期" end-placeholder="结束日期"
                value-format="timestamp"></el-date-picker>
            </el-form-item>
          </el-form>
          <div style="margin-top:20px;">
            <el-button size="small" icon="el-icon-search" class="filter-item" @click="search">筛选</el-button>
            <el-button size="small" icon="el-icon-refresh" class="filter-item" @click="reset">重置</el-button>
          </div>
        </div>
      </div>
      <div style="margin-left: 220px; overflow:auto;margin-right:20px;padding:0px 20px;">
        <h1 class="page_title">跟进任务</h1>
        <div class="filter-container">
          <div style="margin-bottom: 10px;">
            <el-radio-group size="small" v-model="activityType" @change="switchActivityType">
              <el-radio-button :label="0">全部({{ count0 }})</el-radio-button>
              <el-radio-button :label="1">电话({{ count1 }})</el-radio-button>
              <el-radio-button :label="2">到店({{ count2 }})</el-radio-button>
              <el-radio-button :label="3">试驾({{ count3 }})</el-radio-button>
              <el-radio-button :label="4">订车({{ count4 }})</el-radio-button>
              <el-radio-button :label="5">交车({{ count5 }})</el-radio-button>
              <el-radio-button :label="8">回访({{ count8 }})</el-radio-button>
            </el-radio-group>
          </div>
          <div style="margin-bottom: 10px;">
            <el-radio-group size="small" v-model="filterType" @change="retrieveTables">
              <el-radio-button :label="0">今日待完成({{ subcount0 }})</el-radio-button>
              <el-radio-button :label="1">所有待完成({{ subcount1 }})</el-radio-button>
              <el-radio-button :label="2">逾期待完成({{ subcount2 }})</el-radio-button>
              <el-radio-button :label="3">已完成</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <el-table :data="tableRecords" stripe v-loading="listLoading">
          <el-table-column align="left" label="跟进时间" width="120">
            <template slot-scope="scope">{{
              scope.row.activityDate | parseTime("{y}-{m}-{d}")
            }}</template>
          </el-table-column>
          <el-table-column align="left" label="姓名" width="160">
            <template slot-scope="scope">
              <span class="click_link" @click="toDetailPage(scope.row.customerId)">
                {{ `${scope.row.customerName}${ scope.row.customerMobile ? ` - ` : ''}`  }}
                <Desensitize
                  v-if="scope.row.customerMobile"
                  :text="scope.row.customerMobile"
                  :userType="2"
                  :clearText="true"
                  :queryKey="scope.row.customerId"
                  :key="scope.row.customerId"
                />
              </span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="级别" width="120">
            <template slot-scope="scope">{{
              scope.row.level | levelDisplay
            }}</template>
          </el-table-column>
          <el-table-column align="left" label="客户经理" width="90">
            <template slot-scope="scope">{{ scope.row.ownerName }}</template>
          </el-table-column>
          <el-table-column align="left" label="客户来源" width="90">
            <template slot-scope="scope">{{ scope.row.fromSource }}</template>
          </el-table-column>
          <el-table-column align="left" label="任务" width="80">
            <template slot-scope="scope">{{
              scope.row.activityType | activityTypeDisplay
            }}</template>
          </el-table-column>
          <el-table-column align="left" label="最近跟进" min-width="160">
            <template slot-scope="scope">
              <span v-html="scope.row.content.replaceAll('\n', '<br/>')"></span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="是否逾期" width="100">
            <template slot-scope="scope">{{
              scope.row.isDelay ? "已逾期" : ""
            }}</template>
          </el-table-column>
        </el-table>
        <div class="pagination-container">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
            layout="total, sizes, prev, pager, next" :total="total"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Desensitize from "@/components/Desensitize/Desensitize.vue";
var activity_tasks_vm;
export default {
  components: {
    Desensitize
  },
  data() {
    activity_tasks_vm = this;
    return {
      listLoading: false,
      dealer: this.$common.getDealer(),
      user: this.$common.getUser(),
      isAdmin: this.$common.getAdmin(),
      searchQuery: {
        key: "",
        level: [],
        fromType: 0,
        followDateRange: [
          new Date().getTime() - 3600 * 1000 * 24 * 6,
          new Date().getTime(),
        ],
        member: [],
        fromSource: [],
        onlineSource: [],
        businessType: [],
        series: [],
      },
      activityType: 0,
      filterType: 0,
      datePickerOption: {
        shortcuts: [
          {
            text: "今日",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨日",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 364);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      members: [],
      levelOptions: [],
      businessTypeOptions: [],
      fromSourceOptions: [],
      importSourceOptions: [],
      carOptions: [],

      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
      },

      count0: 0,
      count1: 0,
      count2: 0,
      count3: 0,
      count4: 0,
      count5: 0,
      count8: 0,
      subcount0: 0,
      subcount1: 0,
      subcount2: 0,
      subcount3: 0,

      tableRecords: [],
    };
  },
  filters: {
    levelDisplay(level) {
      for (var i = 0; i < activity_tasks_vm.levelOptions.length; i++) {
        var o = activity_tasks_vm.levelOptions[i];
        if (o.dataName == level) {
          return o.dataDisplay;
        }
      }
      return "";
    },
    activityTypeDisplay(type) {
      const displayMap = {
        "1": "沟通",
        "2": "到店",
        "3": "试驾",
        "4": "订车",
        "5": "交车",
        "6": "战败",
        "7": "建档",
        "8": "回访",
        "10": "战败复活",
        "21": "新线索分配",
        "22": "新线索清洗",
        "23": "战败审核",
      };
      return displayMap[type + ""];
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path.startWith("/customer/detail/")) {
        try {
          var listFilters = JSON.parse(sessionStorage.getItem("listFilters"));
          vm.searchQuery = listFilters.searchQuery;
          vm.activityType = listFilters.activityType;
          vm.filterType = listFilters.filterType;
          vm.total = listFilters.total;
          vm.listQuery = listFilters.listQuery;
        } catch (error) { 
          console.log(error)
        }
      }
      vm.getList();
    });
  },
  created() {
    var baseInfo = this.$common.getBaseInfo();
    this.levelOptions = baseInfo.customerLevels;
    this.businessTypeOptions = baseInfo.businessTypes;
    this.fromSourceOptions = baseInfo.customerFromSources;
    this.importSourceOptions = baseInfo.importSources;
    this.retrieveMembers();
    this.retrieveCarOptions();
    this.reset();
  },
  methods: {
    retrieveMembers() {
      var parent = this;
      this.$httpAuth
        .post("/v1/dealerMemberRpc/managerMembers", {
          dealerId: this.dealer.dealerId,
        })
        .then(function (response) {
          parent.members = response.data.data;
          if (!parent.isAdmin) {
            parent.members.push({
              memberId: parent.dealer.userId,
              userName: parent.dealer.name,
            });
          }
        });
    },
    retrieveCarOptions() {
      var parent = this;
      this.$httpAuth
        .post("/v1/dealerRpc/vehicleJsonTree", {
          dealerId: this.dealer.dealerId,
        })
        .then(function (response) {
          parent.carOptions = response.data.data;
        });
    },
    retrieveTotal() {
      this.getActivityTotal(0, 0, "count0");
      this.getActivityTotal(1, 0, "count1");
      this.getActivityTotal(2, 0, "count2");
      this.getActivityTotal(3, 0, "count3");
      this.getActivityTotal(4, 0, "count4");
      this.getActivityTotal(5, 0, "count5");
      this.getActivityTotal(8, 0, "count8");
    },
    retrieveSubTotal(activityType) {
      this.getActivityTotal(activityType, 0, "subcount0");
      this.getActivityTotal(activityType, 1, "subcount1");
      this.getActivityTotal(activityType, 2, "subcount2");
      this.getActivityTotal(activityType, 3, "subcount3");
    },
    switchActivityType() {
      this.getList();
    },
    getActivityTotal(activityType, filterType, column) {
      var parent = this;
      this.$httpAuth
        .post("/v1/taskRpc/list", {
          dealerId: parent.dealer.dealerId,
          activityType: activityType,
          filterType: filterType,
          saleIds: parent.searchQuery.member ? parent.searchQuery.member.join(",") : '',
          seriesIds: parent.searchQuery.series? parent.searchQuery.series.join(",") : '',
          fromType: parent.searchQuery.fromType,
          level: parent.searchQuery.level ? parent.searchQuery.level.join(",") : '',
          onlyTotal: true,
          key: parent.searchQuery.key,
        })
        .then(function (res) {
          parent[column] = res.data.total
          // if (column != "") {
          //   eval("parent." + column + "= response.data.total");
          // }
        });
    },
    search() {
      if (this.filterType === 3 && this.searchQuery.followDateRange[1] - this.searchQuery.followDateRange[0] > 24 * 3600 * 6 * 1000) {
        this.$message({
          type: 'error',
          message: "完成时间查询不能大于7天，请重新选择",
        })
        return
      }
      this.listQuery.page = 1;
      this.getList();
    },
    retrieveTables() {
      this.listQuery.page = 1;
      if (this.filterType === 3) {
        this.searchQuery.followDateRange = [new Date().setHours(0, 0, 0, 0),
        new Date().setHours(0, 0, 0, 0) + 24 * 3600 * 1000 - 1]
      }
      this.getList();
    },
    getList() {
      this.retrieveTotal();
      this.retrieveSubTotal(this.activityType);
      var parent = this;
      this.listLoading = true;
      let params = {
        dealerId: parent.dealer.dealerId,
        pageStart: (parent.listQuery.page - 1) * parent.listQuery.limit,
        pageCount: parent.listQuery.limit,
        activityType: parent.activityType,
        filterType: parent.filterType,
        saleIds: parent.searchQuery.member ? parent.searchQuery.member.join(",") : '',
        seriesIds: parent.searchQuery.series ? parent.searchQuery.series.join(",") : '',
        fromType: parent.searchQuery.fromType,
        level: parent.searchQuery.level ? parent.searchQuery.level.join(",") : '',
        onlyTotal: false,
        key: parent.searchQuery.key,
        dateStart: 0,
        dateEnd: 0,
      };
      if (this.filterType === 3) {
        params.dateStart =
          this.searchQuery.followDateRange != null
            ? Math.floor(this.searchQuery.followDateRange[0] / 1000)
            : 0;
        params.dateEnd =
          this.searchQuery.followDateRange != null
            ? Math.floor(this.searchQuery.followDateRange[1] / 1000)
            : 0;
      }
      this.$httpAuth.post("/v1/taskRpc/list", params).then(function (response) {
        parent.listLoading = false;
        parent.tableRecords = response.data.data;
        parent.total = response.data.total;
      });
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    reset() {
      this.searchQuery = {
        key: "",
        level: [],
        fromType: 0,
        followDateRange: [
          new Date().getTime() - 3600 * 1000 * 24 * 6,
          new Date().getTime(),
        ],
        member: [],
        fromSource: [],
        onlineSource: [],
        businessType: [],
        series: [],
      };
      this.activityType = 0;
      this.retrieveTables();
    },
    toDetailPage(id) {
      var listFilters = {
        searchQuery: this.searchQuery,
        activityType: this.activityType,
        filterType: this.filterType,
        total: this.total,
        listQuery: this.listQuery,
      };
      sessionStorage.setItem("listFilters", JSON.stringify(listFilters));
      this.$router.push({
        path: "/customer/detail/" + id,
      });
    },
  },
};
</script>

<style>
.el-pagination .more+.number {
  display: none !important;
}
</style>
